import './local'
import './App.scss'
import algoliasearch from 'algoliasearch/lite'
import { InstantSearch, Configure, connectStateResults } from 'react-instantsearch-dom'

import HomePage from './components/HomePage'
import GhostUI from './components/GhostUI/GhostUI'
import { getAppIndex } from './functions/getAlgoliaIndex'
import pageLanguage from './functions/pageLanguage'
import { useState } from 'react'
import ResourceEnvironment from './hook/ResourceEnvironment'
import AnalyticsScript from './utils/AnalyticsScript'

const win: any = window
win.dataLayer = win.dataLayer || [];

const searchClient = algoliasearch(
    'A47E3BWDPH',
    'e5c93dfd73b094a9553e9a07349b774e'
)

const appStyle: any = {
    direction: pageLanguage() === 'ar' ? 'rtl' : 'ltr',
}

const gtmPushViewItemList = (hits: any) => {
    let items = hits?.map((hit: any, index: number) => {
        let itemCategory = hit.category.deviceSubType.valueEn
        if (itemCategory === "Smart Phones") itemCategory = "Phones"
        if (itemCategory === "Smart Watches") itemCategory = "Wearables"

        return {
            "item_name": hit.category.name.valueEn,
            "item_category": itemCategory,
            "price": hit.category.minPrice,
            "item_id": hit.category.id,
            "item_variant": "",
            "index": index,
            "item_brand": hit.category.brand.valueEn,
            "currency": "SAR",
            "item_list_name": "Phones and Accessories",
            "Order_type": hit.category.preOrder ? "Pre-order" : "Order",
            "Device_availability": hit.stockStatus.valueEn === "Out of Stock" ? "No" : "Yes",
            "quantity": 1
        }
    });

    win.dataLayer.splice(
        win.dataLayer.findIndex((obj: any) => obj.event === "view_item_list"), 1)
    win.dataLayer.push({ ecommerce: null });
    win.dataLayer.push({
        "event": "view_item_list",
        "ecommerce": {
            "user_id": "",
            "login_type": "not_logged_in",
            "screen_type": "devices-homepage",
            "screen_name": "devices-homepage",
            "language_selected": pageLanguage() === 'ar' ? "AR" : "EN",
            "currency": "SAR",
            "items": items,
        }
    })
    items = []
}

const StateResults = ({ searchResults }: any) => {
    const hasResults = searchResults
    gtmPushViewItemList(searchResults?.hits);

    return (
        <>
            <div hidden={!hasResults}>
                <HomePage />
            </div>
            <div hidden={hasResults}>
                <GhostUI />
            </div>
        </>
    )
}

const CustomStateResults = connectStateResults(StateResults)

function App() {
    const [env, setEnv] = useState(false);
    return (
        <div className='Devices__HomepageApp' id="App" style={appStyle}>
            <ResourceEnvironment setEnv={setEnv} />
            {env && (
                <>
                    {window.location.origin.includes("localhost") && <AnalyticsScript />}
                    <InstantSearch searchClient={searchClient} indexName={getAppIndex()}>
                        <Configure hitsPerPage={32} />
                        <CustomStateResults />
                    </InstantSearch>
                </>
            )}
        </div>
    )
}

export default App
